import React, {useEffect} from 'react';
import {Box, Button, CircularProgress, Table, TableBody, TableHead} from "@mui/material";
import {StyledTableCell, StyledTableRow} from '../common/table/TableStyles';
import TableLoadingMockup from "../common/table/TableLoadingMockup";
import Typography from "@mui/material/Typography";
import {useNavigate} from "react-router-dom";
import {useLazyGetFeedbacksQuery} from "../../store/rtk-api/review/review";
import IsError from "../common/IsError";
import {useAppDispatch, useTypedSelector} from "../../store";
import {setFeedbackCount} from "../../store/calendar/calendar.slice";

type Props = {
    rowsPerPage: number,
}

const mapping = {
    'visitDate': 'Дата визита',
    'doctorName': 'Врач',
    'patient': 'Пациент',
    'grade': 'Оценка',
    'review': 'Отзыв',
    'reply': 'Ответ клиники',

}

const ReviewList: React.FC<Props> = ({rowsPerPage}) => {
    const dispatch = useAppDispatch()
    const {...filterData} = useTypedSelector(state => state.review)
    const [getFeedbacks, {data: feedbacks, isError, isLoading}] = useLazyGetFeedbacksQuery()
    let loading = false
    useEffect(() => {
        loading = true
        getFeedbacks(filterData).then(res => {
            loading = false
        })
    }, [filterData.query, filterData.is_responded, filterData.star, filterData.created_date, filterData.page])

    useEffect(() => {
        if (feedbacks) {
            dispatch(setFeedbackCount(feedbacks?.count))
        }
    }, [feedbacks?.count])

    const navigate = useNavigate()
    const redirectToReplyPage = (name: string, lastName: string, middleName: string, star: number, comment: string, patient: string, date: string, id: number, image: string) => {
        navigate('reply', {
            state: {
                name,
                lastName,
                middleName,
                star,
                comment,
                date,
                patient,
                id,
                image
            }
        })
    }

    return (
        <>

            <IsError isError={isError}/>
            {loading && <CircularProgress/>}
            <Table>
                <TableHead>
                    <StyledTableRow>
                        {Object.values(mapping).map((title, idx) => {
                            return (
                                <StyledTableCell key={idx} align={"left"}>{title}</StyledTableCell>
                            )
                        })}
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {isLoading ?
                        <TableLoadingMockup cellCount={6} rowCount={rowsPerPage}/>
                        :
                        feedbacks?.results?.map((item, ind) => (
                            <StyledTableRow key={item?.id}>
                                <StyledTableCell>{item?.visit_date}</StyledTableCell>
                                <StyledTableCell>
                                    <Box sx={{display: "flex", alignItems: "center", gap: "10px"}}>
                                        <img style={{
                                            borderRadius: "50px",
                                            height: "40px",
                                            width: "40px"
                                        }}
                                             src={item?.doctor?.photo}

                                        />
                                        <Typography>{`${item?.doctor?.last_name} ${item?.doctor?.first_name} ${item?.doctor?.middle_name}`}</Typography>
                                    </Box>

                                </StyledTableCell>
                                <StyledTableCell>{`${item?.patient.phone} ${item?.patient.first_name}`}</StyledTableCell>
                                <StyledTableCell>{item?.star}</StyledTableCell>
                                <StyledTableCell>{item?.text}</StyledTableCell>
                                <StyledTableCell>
                                    <Button variant={"outlined"} sx={{
                                        borderRadius: "10px",
                                        backgroundColor: "#fff",
                                        border: "1px solid #666666",
                                        color: "#666666",
                                        textTransform: "capitalize"
                                    }} onClick={() => redirectToReplyPage(
                                        item?.doctor?.first_name,
                                        item?.doctor?.last_name,
                                        item?.doctor?.middle_name,
                                        item?.star,
                                        item?.text,
                                        item?.patient.first_name,
                                        item?.visit_date,
                                        item?.id,
                                        item?.doctor?.photo
                                    )}>Написать ответ</Button>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                </TableBody>
            </Table>
            {feedbacks?.results.length === 0 && <div style={{padding: "10px"}}>Данных нет...</div>}
        </>
    );
};

export default ReviewList;